export default "__VITE_ASSET__CdL9vRVV__"